module.exports = __webpack_public_path__ + "img/pantalla-9-3.b4586602.png";